import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { StatusCodeState } from './status-code.state';
import { StatusCodeInitialState, StatusCodeLoad } from './status-code.actions';
import { SetInitialStateFacade } from '../../../../common';
import { FilterPopupChipsModel, FilterPopupChipsFacade } from '../models/filter-popup-chips.model';

@Injectable()
export class StatusCodeFacade implements FilterPopupChipsFacade, SetInitialStateFacade {
  items$: Observable<FilterPopupChipsModel[]> = this.store.select(StatusCodeState.getStatusCode);
  loaded$: Observable<boolean> = this.store.select(StatusCodeState.getLoaded);

  constructor(private store: Store) {}

  load(): void {
    this.store.dispatch(new StatusCodeLoad());
  }

  setInitialState(): void {
    this.store.dispatch(new StatusCodeInitialState());
  }
}
